import { MovieClip, TextField, TextFormat } from "./runtime";

/**
 * Frames the attribution card owns before the game boots. The boot timeline
 * runs at 30fps, so this is two seconds; `Game.maxIntro` counts the same window
 * and cuts it short on the first key or pointer press.
 */
export const INTRO_FRAMES = 60;

/** Frames spent fading the card in, and again fading it out. */
const FADE_FRAMES = 12;

/**
 * Occupies the main-timeline frame-2 window that the SWF used for its sponsor
 * logo animation. The sponsor branding is not part of this port, so the slot
 * carries the port's attribution card instead.
 */
export class IntroClip extends MovieClip {
  private life = 0;

  constructor() {
    super();

    const titleFormat = new TextFormat();
    titleFormat.font = "TRS Million";
    titleFormat.bold = true;
    titleFormat.size = 48;
    titleFormat.color = 0x66ffee;
    titleFormat.align = "center";
    const title = new TextField();
    title.defaultTextFormat = titleFormat;
    title.embedFonts = true;
    title.selectable = false;
    title.width = 720;
    title.height = 70;
    title.y = 196;
    title.text = "XENOS";
    this.addChild(title);

    const creditFormat = new TextFormat();
    creditFormat.font = "PF Ronda Seven";
    creditFormat.size = 14;
    creditFormat.color = 0x7fb8b3;
    creditFormat.align = "center";
    const credit = new TextField();
    credit.defaultTextFormat = creditFormat;
    credit.embedFonts = true;
    credit.selectable = false;
    credit.width = 720;
    credit.height = 24;
    credit.y = 262;
    credit.text =
      "A port of the original game by Oddity, published on MaxGames in 2011";
    this.addChild(credit);

    this.alpha = 0;
  }

  /** Called once per stage frame while the card is on screen. */
  advance(): void {
    this.life++;
    const fadeOutAt = INTRO_FRAMES - FADE_FRAMES;
    if (this.life <= FADE_FRAMES) {
      this.alpha = this.life / FADE_FRAMES;
    } else if (this.life >= fadeOutAt) {
      this.alpha = Math.max(0, (INTRO_FRAMES - this.life) / FADE_FRAMES);
    } else {
      this.alpha = 1;
    }
  }
}
